import React, { useMemo, useCallback, useState } from 'react';
import { Box, FormControl, FormControlLabel, IconButton, Link, Switch } from '@material-ui/core';
import ReactHTMLParser from 'react-html-parser';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { Launch } from '@material-ui/icons';

import DataTable from '../../../../components/DataTable';
import useDoubts, { DOUBT_FILTERS } from './useDoubts';
import { producaov2 } from '../../../../services/apis';
import TicketsSummary from './TicketsSummary';

const status = [
  { key: 0, name: "Todos" },
  { key: 1, name: "Em aberto" },
  { key: 2, name: "Expirada" },
  { key: 3, name: "Respondida" },
];

const ticketDate = (dataResposta) => {
  if (!dataResposta) return null;

  const dataISO = `${new Date(dataResposta).toISOString()}`.split('Z')[0];
  const dataISOTreated = `${
    `${new Date(dataISO).toISOString()}`.split('Z')[0]
  }+00:00`;
  const dataEnvio = new Date(dataISOTreated);

  return dataEnvio;
};

export default function DuvidasNovo() {
  const {
    data,
    isLoading,
    filters,
    page,
    rowsPerPage,
    total,
    changeFilters,
    clearFilters,
    changePage,
    changeRowsPerPage,
  } = useDoubts();

  const [answeredTickets, setAnsweredTickets] = useState({});
  const [loadingTicketsIDsUpdate, setLoadingTicketsIDsUpdate] = useState([]);

  const handleAnswerTicket = useCallback(async ({ ticketID, isAnswered }) => {
    setAnsweredTickets(prev => {
      return ({...prev, [ticketID]: isAnswered});
    });

    const tickets = data;

    const ticket = tickets.find(ticket => ticket.id === ticketID);

    setLoadingTicketsIDsUpdate(prev => [...prev, ticketID]);

    try {
      await producaov2.put(`admin/operacoes/controle-tickets-update/${ticket.id}?${ticket.mensagem === "Resposta" ? `isResposta=1` : ""}`,
        {
          is_pendente: !isAnswered,
          is_expirada: 0,
          is_analise: ticket.is_analise,
        }
      );

      let logs = {
        local: "ead/Duvidas",
        texto: `editou o status do ticket de id=${ticket?.id}`,
      };

      producaov2.post("system_logs", { acao: JSON.stringify(logs) });
    } catch(error) {
      toast.error(`Houve um erro ao atualizar o status de ${ticket?.nome_pessoa}`);

      /**
       * Resetando o status quando der erro
       */
      setAnsweredTickets(prev => {
        return ({...prev, [ticketID]: !isAnswered});
      });
    } finally {
      setLoadingTicketsIDsUpdate(prev => prev.filter(id => id !== ticketID));
    }
  }, [data]);

  const rows = useMemo(() => {
    return data?.map(ticket => {
      return {
        id: ticket?.id,
        user: (
          <Link title={ticket?.nome_pessoa} color="primary" underline="hover" href={`/admin/alunos/detalhes/${ticket.id_pessoa}`} target="_blank">
            {ticket?.nome_pessoa}
          </Link>
        ),
        doubt: (
          <Link title={ticket?.mensagem} color="primary" underline="hover" href={`/online/tickets/${ticket.id_duvida}`} target="_blank">
            {ReactHTMLParser(ticket?.mensagem)}
          </Link>
        ),
        tutorID: ticket?.id_tutor,
        created_at: format(ticketDate(new Date(ticket?.data_envio)), 'dd/MM/yyyy hh:mm:ss'),
        isPending: ticket?.is_pendente,
        isExpired: ticket?.is_expirada,
        actions: (
          <IconButton href={`/online/tickets/${ticket.id}`} target="_blank">
            <Launch />
          </IconButton>
        )
      }
    })
  }, [data]);

  return (
    <Box display="flex" flexDirection="column" gridRowGap="1rem">
      <TicketsSummary />
      <DataTable
        showFilters
        isLoading={isLoading}
        filters={[
          { key: DOUBT_FILTERS.STATUS, name: 'Status', component: { type: 'select', options: status } },
          { key: DOUBT_FILTERS.SEARCH, name: 'Aluno', component: { type: 'text', placeholder: 'Procurar aluno' } },
          { key: DOUBT_FILTERS.DOUBT_SEARCH, name: 'Termo', component: { type: 'text', placeholder: 'Procurar por termo da mensagem' } },
          { key: DOUBT_FILTERS.START_DATE, name: 'De', component: { type: 'date' } },
          { key: DOUBT_FILTERS.END_DATE, name: 'Até', component: { type: 'date' } },
        ]}
        columns={[
          { key: 'user', name: 'Aluno', isSingleLine: true },
          { key: 'doubt', name: 'Dúvida', maxWidth: '500px' },
          { key: 'created_at', name: 'Data' },
          {
            key: 'status',
            name: 'Status',
            renderCustomRow: (row) => {
              const isAnswered = typeof answeredTickets[row?.id] === 'undefined'
                ? !row?.isPending && !row?.isExpired
                : answeredTickets[row?.id];

              const label = isAnswered
                ? "Respondida"
                : (row?.isExpired ? "Expirada" : "Em aberto")
              
              return (
                <FormControl>
                  <FormControlLabel
                    label={label}
                    labelPlacement="bottom"
                    disabled={loadingTicketsIDsUpdate.includes(row?.id)}
                    control={
                      <Switch
                        color="primary"
                        checked={isAnswered}
                        onChange={(_, isAnswered) => handleAnswerTicket({ ticketID: row?.id, isAnswered })}
                      />
                    }
                  />
                </FormControl>
              )
            }
          },
        ]}
        rows={rows}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        selectedFilters={filters}
        totalRecords={total}
        onPageChange={(page) => changePage(page + 1)}
        onRowsPerChange={changeRowsPerPage}
        onResetFilters={clearFilters}
        onSubmitFilters={changeFilters}
      />
    </Box>
  );
}